import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { updateOrg } from 'js/actions/org-actions';
import { LoadingMessage } from 'js/components';
import { orgStructureSyncKey } from '../components/ManageOrg/orgWeightsUtils';
import OrgWeights from '../components/ManageOrg/OrgWeights';

function OrgWeightsContainer({
  organization,
  loading: orgLoading,
  errorLoading,
  updateOrg,
}) {
  const orgSyncKey = useMemo(
    () => orgStructureSyncKey(organization),
    [organization]
  );

  const handlePersist = useCallback(
    (orgId, payload) => updateOrg(orgId, payload),
    [updateOrg]
  );

  if (!organization && !errorLoading && orgLoading) {
    return <LoadingMessage iconSize="2x">Loading organization…</LoadingMessage>;
  }

  if (!organization) {
    return null;
  }

  return (
    <OrgWeights
      organization={organization}
      orgSyncKey={orgSyncKey}
      onPersist={handlePersist}
    />
  );
}

export default connect(null, { updateOrg })(OrgWeightsContainer);
